export const asRecord = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;

export const parseToolOutputRecord = (output: unknown): Record<string, unknown> | null => {
  if (typeof output === "string") {
    try {
      return asRecord(JSON.parse(output));
    } catch {
      return null;
    }
  }

  return asRecord(output);
};

export const firstString = (...values: unknown[]): string | undefined => {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return undefined;
};

export const getNestedRecord = (
  record: Record<string, unknown> | null | undefined,
  key: string,
): Record<string, unknown> | null => asRecord(record?.[key]);

export const unwrapToolOutputRecord = (output: unknown): Record<string, unknown> | null => {
  const result = parseToolOutputRecord(output);
  if (!result) {
    return null;
  }
  return getNestedRecord(result, "results") ?? result;
};
